<template>
  <div class="page" id="page">
    <div class="background">
      <div id="topPlaceholder" :style="{ transform: 'translateY(' + scrollTop/4*-1 + 'px)' }"></div>
      <img id="logo1" src="./img/logo-1v3@2x.png" alt="logo1" />
      <img id="logo2" src="./img/logo-2v3@2x.png" alt="logo2" />
      <img
        id="sky"
        src="./img/bg-skyv3@2x.png"
        :style="{ transform: 'translateY(' + scrollTop/8 + 'px)' }"
        alt="sky"
      />
      <img
        id="recruit-title"
        src="./img/titlev4@2x.png"
        :style="{ transform: 'translateY(' + scrollTop/-3 + 'px)' }"
        alt="job"
      />
      <img
        id="tower"
        src="./img/bg-towerv3@2x.png"
        :style="{ transform: 'translateY(' + scrollTop/4 + 'px)' }"
        alt="tower"
      />
    </div>

    <div class="recruit-content">
      <section class="recruit-slogan">
        <div class="slogan-content">
          <p>加入我们，一起造未来！</p>
          <p>让有才华的你，获得更大的平台</p>
          <p>
            中国平安《财富》
            <span>世界500强，全球第29位</span>
          </p>
          <p>金融+科技赋能领跑行业</p>
          <p>
            互联网产品
            <span>金管家拥有亿级用户量</span>
          </p>
          <p>更多新业务等你来造…</p>
        </div>
      </section>
      <section class="fringe-benefits">
        <span
          class="title1"
          :style="{ transform: 'translate(' + gammaDis + 'px,' + (betaDis -15) + 'px)' }"
        >FRINGE BENEFITS</span>
        <span class="title2">福利待遇</span>
        <div class="benefits-content">
          <ul>
            <li class="benefits-li" v-for="(benefits, index) in benefitsData" v-bind:key="index">
              <img :src="benefits.src" alt />
              <div>
                <span class="benefits-li-title">{{ benefits.title }}</span>
                <span class="benefits-li-content">{{ benefits.content }}</span>
              </div>
            </li>
          </ul>
        </div>
      </section>

      <section class="recruit-posts">
        <span
          class="title1"
          :style="{ transform: 'translate(' + gammaDis + 'px,' + (betaDis -15) + 'px)' }"
        >RECRUITMENT POSTS</span>
        <span class="title2">招聘岗位</span>
        <div class="posts-content">
          <div class="post-card" v-for="(job,index) in jobsData"  v-show="!job.hide" v-bind:key="index">
            <div class="post-info">
              <div class="title-and-salary">
                <span class="title">{{ job.title }}</span>
                <!-- <span class="salary" v-show="job.salary">{{ job.salary }}</span> -->
              </div>
              <div class="basic-introduction">
                <span>{{ job.basic }}</span>
                <button class="showInfo active" v-show="!job.unfold" @click="toggleFoldStatus(index, true)">
                  展开
                  <div></div>
                </button>
              </div>
            </div>

            <div class="job-description" v-show="job.unfold">
              <div class="title">
                <div></div>
                <span>{{ job.jobDescription.title }}</span>
              </div>
              <ul>
                <li class="contents" v-for="(item,index) in job.jobDescription.content" v-bind:key="index">
                  <span class="NO">{{ index + 1 }}</span>
                  <span class="list-content">{{ item }}</span>
                </li>
              </ul>
            </div>

            <div class="job-requirement" v-show="job.unfold">
              <div class="title">
                <div></div>
                <span>{{ job.employRequirement.title }}</span>
              </div>
              <ol>
                <li class="contents" v-for="(item,index) in job.employRequirement.content" v-bind:key="index">
                  <span class="NO">{{ index + 1 }}</span>
                  <span class="list-content">{{ item }}</span>
                </li>
              </ol>
              <div class="job-tips">
                <span>{{job.tips}}</span>
              </div>
            </div>

            <div class="hidden-info-control" v-show="job.unfold">
              <button class="hiddenInfo active" @click="toggleFoldStatus(index, false)">
                收起
                <div></div>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section class="resume-delivery">
        <span
          class="title1"
          :style="{ transform: 'translate(' + gammaDis + 'px,' + (betaDis -15) + 'px)' }"
          >RESUME DELIVERY</span>
        <span class="title2">简历投递</span>
        <div class="delivery-content">
          <div class="contact-info" v-for="(contact, index) in contactMethods" v-bind:key="index">
            <p class="contact-info-header">{{ contact.title }}</p>
            <p class="contact-info-content">{{ contact.content }}</p>
          </div>
          <div class="other-info">
            <p>内部推荐可以更快收获offer</p>
            <p>欢迎通过团队成员投递简历</p>
          </div>
        </div>
      </section>
      <img id="base-img" src="./img/bottomv3@2x.png" alt />
    </div>
  </div>
</template>

<script>
import PALifeWX from '@palife/lib-wx'
import recruitData from './getRecruitData'

export default {
  data () {
    return {
      postCardHeight: 0,
      scrollTop: 0,
      alphaDis: 0,
      betaDis: 0,
      gammaDis: 0,
      benefitsData: [
        {
          src: require('./img/xinchoudaiyuv3@2x.png'),
          title: '优厚的薪酬待遇',
          content: '月薪+年终奖高于行业薪资水平'
        },
        {
          src: require('./img/jierifuliv3@2x.png'),
          title: '节日福利',
          content: '法定或特定节假日可领取礼品'
        },
        {
          src: require('./img/daixinxiujiav3@2x.png'),
          title: '带薪休假',
          content: '根据员工工龄每年享有带薪年假'
        },
        {
          src: require('./img/dibiaobangongv3@2x.png'),
          title: '地标办公',
          content: '深圳最高楼平安金融中心，一流环境'
        },
        {
          src: require('./img/tuanduihuodong3@2x.png'),
          title: '定期团队活动',
          content: '定期组织进行团建活动，旅游、聚餐等'
        },
        {
          src: require('./img/xuexipeixunv3@2x.png'),
          title: '学习培训',
          content: '提供技术分享培训，平安大学学习机会'
        }
      ],
      jobsData: [],
      contactMethods: []
    }
  },
  methods: {
    toggleFoldStatus: function (index, isUnfold) {
      this.jobsData[index].unfold = isUnfold
      // 利用锚点记录岗位卡片展开情况
      // 将锚点当做查询参数是防止微信分享时干掉锚点
      const currentUrl = window.location.origin + window.location.pathname
      const newUrl =
        currentUrl +
        '?unfoldCards=' +
        this.unfoldCards +
        '&hideCards=' +
        this.hideCards
      window.history.replaceState({ path: newUrl }, '', newUrl)
      this.setShare(newUrl)

      // 判断此卡片是否准备关闭
      if (!isUnfold) {
        const div = document.body.querySelectorAll('.post-card')[index]
        const { height } = div.getBoundingClientRect()
        // 保持招聘卡片的底部不移动
        this.setScrollTop(-this.scrollTop - height + this.postCardHeight)
      }
    },
    //
    onScroll: function () {
      this.scrollTop = document
        .getElementById('page')
        .getBoundingClientRect().top
    },
    orientationHandler: function (event) {
      // 手机旋转
      this.alphaDis = Math.sin(((event.alpha || 0) / 180) * 3.14) * 50
      // 手机前后倾斜，前负后正
      this.betaDis = Math.sin(((event.beta || 0) / 180) * 3.14) * 60
      // 手机左右倾斜，左负右正
      this.gammaDis =
        Math.sin(((event.gamma || 0) / 180) * 3.14) *
        100 *
        Math.cos(((event.beta || 0) / 180) * 3.14)
    },
    setScrollTop: function (scrollTop) {
      document.documentElement.scrollTop = scrollTop
      window.pageYOffset = scrollTop
      document.body.scrollTop = scrollTop
    },
    setShare: function (url) {
      PALifeWX.init({
        isProd: true
      })
      PALifeWX.setOnShare({
        title: '平安金管家社会招聘中',
        desc: '成就非凡的路上，你准备好了吗？加入我们，从这里开始！',
        link: url || window.location.href,
        imgUrl:
          'http://stg1-als.cdn.lifeapp.pingan.com.cn/ph/job/job_logo.png',
        success: () => {},
        cancel: () => {},
        fail: () => {}
      })
    }
  },
  computed: {
    unfoldCards: function () {
      return this.jobsData
        .map((item, index) => {
          if (item.unfold) {
            return index
          }
        })
        .filter(v => v !== undefined)
        .join('-')
    },
    hideCards: function () {
      return this.jobsData
        .map((item, index) => {
          if (item.hide) {
            return index
          }
        })
        .filter(v => v !== undefined)
        .join('-')
    }
  },
  created () {
    this.setShare()
    this.jobsData = recruitData.jobsData
    this.contactMethods = recruitData.contactMethods

    // 获取卡片展开和隐藏
    let searchStr = window.location.search.slice(1)
    let query = searchStr.split('&').reduce((result, item) => {
      let [key, value] = item.split('=')
      return { ...result, [key]: value ? value.split('-') : [] }
    }, {})
    if (query.unfoldCards) {
      query.unfoldCards.map((item) => {
        if (this.jobsData[item] !== undefined) {
          this.jobsData[item].unfold = true
        }
      })
    }
    if (query.hideCards) {
      query.hideCards.map((item) => {
        if (this.jobsData[item] !== undefined) {
          this.jobsData[item].hide = true
        }
      })
    }
  },
  mounted () {
    // 获取未展开卡片的高度，1.65rem
    this.postCardHeight = parseInt(getComputedStyle(window.document.documentElement)['font-size']) * 1.65
    window.addEventListener('scroll', this.onScroll)
    if (window && window.DeviceOrientationEvent) {
      window.addEventListener('deviceorientation', this.orientationHandler, false)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}

body {
  font-size: 16PX;
  -webkit-text-size-adjust: none !important;
}

.page {
  background: #2541a3;
  width: 750px;
}

/* 背景图片 */
.page > .background {
  position: relative;
  height: 1400px;
  overflow: hidden;
}

#topPlaceholder {
  position: absolute;
  width: 750px;
  height: 181px;
  background: #243db7;
}
#tower {
  position: absolute;
  width: 750px;
  height: 1400px;
  top: 0;
}
#sky {
  position: absolute;
  width: 750px;
  height: 1400px;
  top: 0;
}
#logo1 {
  position: absolute;
  width: 219px;
  height: 37px;
  top: 30px;
  left: 48px;
  z-index: 10;
}
#logo2 {
  position: absolute;
  width: 180px;
  height: 18px;
  top: 30px;
  right: 48px;
  z-index: 10;
}
#recruit-title {
  position: absolute;
  width: 491px;
  height: 267px;
  top: 205px;
  left: 130px;
}
#base-img {
  width: 750px;
  height: 380px;
  margin-top: -100px;
}

/* 具体内容 */

.recruit-content {
  position: relative;
  margin-top: -323px;
}

section {
  margin-left: 42px;
  margin-right: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

section > span.title1 {
  position: absolute;
  top: 60px;
  opacity: 0.1;
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 48px;
  color: #ddc9ff;
  letter-spacing: 0;
  text-align: center;
}
section > span.title2 {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 48px;
  color: #f1c395;
  text-align: center;
  margin-top: 89px;
  margin-bottom: 36px;
}

/* 招聘口号 */
.recruit-content > .recruit-slogan {
  width: 666px;
  padding: 56px 0;
  background: url(./img/card1v4@2x.png);
  background-size: cover;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
}

section.recruit-slogan > .slogan-content > p {
  font-family: PingFangSC;
  font-size: 30px;
  color: #755739;
  text-align: center;
  line-height: 42px;
  margin: 24px 0;
  letter-spacing: 0;
  white-space: nowrap;
}
.recruit-slogan > .slogan-content > p > span {
  font-family: PingFangSC-Medium;
  color: #ff8f1f;
}

/*福利待遇*/

.benefits-content {
  width: 666px;
  padding-top: 48px;
  padding-bottom: 40px;
  background: url(./img/card2v4@2x.png);
  background-size: 100% 100%;
  box-shadow: 0 6PX 18PX 0 rgba(24, 18, 127, 0.5);
  border-radius: 4PX;
}
.benefits-li {
  margin-top: 33px;
  margin-left: 50px;
  display: flex;
}
.benefits-li:first-child {
  margin-top: 0;
}
.benefits-li > img {
  width: 60px;
  height: 60px;
}
.benefits-li > div {
  margin-left: 30px;
}
.benefits-li span {
  display: block;
}
.benefits-li-title{
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 30px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 44px;
  margin-bottom: 4px;
}
.benefits-li-content{
  font-family: SourceHanSansSC-Regular;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 44px;
}

/* 招聘岗位 */

.post-card {
  width: 666px;
  background: #fffbf5;
  box-shadow: 0 6PX 18PX 0 rgba(24, 18, 127, 0.5);
  border-radius: 4PX;
  padding: 36px;
  margin-bottom: 30px;
}
.post-card:last-child {
  margin-bottom: 0;
}
.title-and-salary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.title-and-salary > .title {
  font-family: SourceHanSansSC-Medium;
  font-weight: bold;
  font-size: 36px;
  line-height: 52px;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: 0;
  flex-grow: 1;
}
.title-and-salary > .salary {
  font-family: DINAlternate-Bold;
  font-weight: bold;
  font-size: 30px;
  color: #ff661f;
  letter-spacing: 0;
  flex-grow: 1;
  text-align: right;
}
.basic-introduction {
  display: flex;
  justify-content: space-between;
}
.basic-introduction > span {
  display: inline-block;
  opacity: 0.6;
  font-family: SourceHanSansSC-Regular;
  font-size: 24px;
  line-height: 35px;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: 0;
}
.basic-introduction > span{
  flex-grow: 1;
}
.post-card button {
  display: none;
}
.post-card button.active {
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 0.6;
  font-family: SourceHanSansSC-Regular;
  font-size: 24px;
  line-height: 35px;
  color: rgba(0, 0, 0, 0.45);
  letter-spacing: 0;
  border: none;
  background: transparent;
}
.post-card button.active > div {
  width: 10px;
  height: 10px;
  border: 2PX solid rgba(0, 0, 0, 0.45);
  border-top: none;
  border-right: none;
  transform: rotate(-45deg);
  margin-left: 10px;
}
.post-card .hidden-info-control {
  display: flex;
  justify-content: flex-end;
}
.post-card .hidden-info-control > button.active > div {
  transform: rotate(135deg);
}

/* 目测样式 */
.post-card > .job-description {
  margin-top: 48px;
}
.post-card > .job-requipxent {
  margin-top: 42px;
}
.job-description > .title,
.job-requipxent > .title {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.job-description > .title > div,
.job-requipxent > .title > div {
  width: 36px;
  height: 26px;
  border-left: 6PX solid #ff661f;
}
.job-description > .title > span,
.job-requipxent > .title > span {
  font-family: SourceHanSansSC-Medium;
  font-weight: bold;
  font-size: 36px;
  color: rgba(0, 0, 0, 0.85);
  flex-grow: 1;
}
.post-card .contents {
  display: flex;
  flex-direction: row;
  margin-top: 20px;
}
.post-card .contents > .NO {
  width: 36px;
  flex-shrink: 0;
}
.post-card .contents > span {
  font-family: SourceHanSansSC-Regular;
  font-size: 26px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 44px;
}
.contents > .list-content{
    flex-grow: 1;
}
.job-tips {
  margin-top: 10px;
}
.job-tips > span {
  font-family: SourceHanSansSC-Regular;
  font-size: 26px;
  color: rgba(0, 0, 0, 0.7);
  opacity: 0.7;
  line-height: 44px;
  margin-top: 20px;
}
/**/

/* 简历投递 */

.delivery-content {
  width: 666px;
  padding-top: 12px;
  padding-bottom: 60px;
  background: url(./img/card2v4@2x.png);
  background-size: 100% auto;
  box-shadow: 0 6PX 18PX 0 rgba(24, 18, 127, 0.5);
  position: relative;
}
.delivery-content:after {
  content: "";
  display: block;
  height: 30px;
  background: url(./img/card2v4@2x.png) 0 100%;
  background-size: 100% auto;
  position: absolute;
  width: 100%;
  bottom: -29px;
}

.delivery-content > div {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.delivery-content > .contact-info {
  margin-top: 36px;
}

.delivery-content > .contact-info > .contact-info-header {
  font-family: SourceHanSansSC-Regular;
  font-size: 28px;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: 0;
  margin-bottom: 6px;
}
.delivery-content > .contact-info > .contact-info-content {
  font-family: SourceHanSansSC-Regular;
  font-size: 36px;
  line-height: 52px;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: 0;
}
.delivery-content > .copy {
  margin-top: 36px;
  font-family: SourceHanSansSC-Regular;
  font-size: 26px;
  line-height: 55px;
  width: 147px;
  margin-left: auto;
  margin-right: auto;
  color: #ffffff;
  letter-spacing: 0;
  background: #deb184;
  border-radius: 27.5px;
}

.delivery-content > .other-info {
  margin-top: 53px;
  height: 76px;
  display: flex;
  justify-content: space-between;
}
.delivery-content > .other-info > p {
  opacity: 0.6;
  font-family: SourceHanSansSC-Regular;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
  letter-spacing: 0;
}
</style>
